import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Header({ siteLang, setSiteLang }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [showConfirm, setShowConfirm] = useState(false);

  const nav = {
    FR: ['Accueil', 'Le composite card', 'Comment ça marche', 'Tarifs', 'FAQ', 'Contact'],
    EN: ['Home', 'The composite card', 'How it works', 'Pricing', 'FAQ', 'Contact'],
  };

  const routes = ['/', '/composite-card', '/comment-ca-marche', '/tarifs', '/faq', '/contact'];

  const handleCreateClick = () => {
    if (location.pathname === '/editeur') {
      setShowConfirm(true);
    } else {
      navigate('/editeur');
    }
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    navigate('/editeur');
    window.location.reload();
  };

  return (
    <>
      {showConfirm && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 99999, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Arial, sans-serif' }}>
          <div style={{ backgroundColor: '#1A1A1A', color: '#fff', width: '100%', maxWidth: '420px', margin: '16px', padding: '32px', position: 'relative', boxShadow: '0 8px 40px rgba(0,0,0,0.6)' }}>
            {[
              { top: 0, left: 0, borderTop: '2px solid #FF0066', borderLeft: '2px solid #FF0066' },
              { top: 0, right: 0, borderTop: '2px solid #FF0066', borderRight: '2px solid #FF0066' },
              { bottom: 0, left: 0, borderBottom: '2px solid #FF0066', borderLeft: '2px solid #FF0066' },
              { bottom: 0, right: 0, borderBottom: '2px solid #FF0066', borderRight: '2px solid #FF0066' },
            ].map((corner, i) => (
              <div key={i} style={{ position: 'absolute', width: '12px', height: '12px', ...corner }} />
            ))}
            <p style={{ margin: '0 0 8px', fontSize: '14px', fontWeight: '900', letterSpacing: '2px', color: '#FF0066' }}>COMPIFY</p>
            <p style={{ margin: '0 0 10px', fontSize: '16px', fontWeight: '700' }}>
              {siteLang === 'FR' ? 'Nouveau composite ?' : 'New composite?'}
            </p>
            <p style={{ margin: '0 0 24px', fontSize: '13px', color: '#888', lineHeight: 1.6 }}>
              {siteLang === 'FR' ? 'Votre travail en cours sera perdu. Voulez-vous vraiment repartir de zéro ?' : 'Your current work will be lost. Do you really want to start over?'}
            </p>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => setShowConfirm(false)} style={{ flex: 1, padding: '12px', backgroundColor: 'transparent', border: '1px solid #444', color: '#888', cursor: 'pointer', fontSize: '11px', fontWeight: '700', letterSpacing: '2px' }}>
                {siteLang === 'FR' ? 'ANNULER' : 'CANCEL'}
              </button>
              <button onClick={handleConfirm} style={{ flex: 1, padding: '12px', backgroundColor: '#FF0066', border: 'none', color: '#fff', cursor: 'pointer', fontSize: '11px', fontWeight: '700', letterSpacing: '2px' }}>
                {siteLang === 'FR' ? 'RECOMMENCER' : 'START OVER'}
              </button>
            </div>
          </div>
        </div>
      )}

      <header style={{ backgroundColor: '#1A1A1A', borderBottom: '2px solid #FF0066', padding: '0 40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '80px', position: 'sticky', top: 0, zIndex: 100, flexShrink: 0 }}>
        <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '16px' }} onClick={() => navigate('/')}>
          <img src="/logo-compify.svg" alt="Compify" style={{ height: '40px', display: 'block' }} />
          <div style={{ width: '1px', height: '24px', backgroundColor: '#333', flexShrink: 0 }} />
          <span style={{ color: '#666', fontSize: '9px', letterSpacing: '2px', fontWeight: '700', whiteSpace: 'nowrap' }}>
            {siteLang === 'FR' ? 'LA CARTE DE VISITE DU MANNEQUIN ET DU COMÉDIEN' : 'THE COMPOSITE CARD FOR MODELS AND ACTORS'}
          </span>
        </div>
        <nav style={{ display: 'flex', gap: '24px' }}>
          {nav[siteLang].map((item, i) => (
            <span key={item} onClick={() => navigate(routes[i])} style={{
              color: location.pathname === routes[i] ? '#FF0066' : '#aaa',
              fontSize: '13px', letterSpacing: '0.5px', cursor: 'pointer', transition: 'color 0.2s'
            }}
              onMouseEnter={e => e.target.style.color = '#FF0066'}
              onMouseLeave={e => e.target.style.color = location.pathname === routes[i] ? '#FF0066' : '#aaa'}
            >{item}</span>
          ))}
        </nav>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <div style={{ display: 'flex', border: '1px solid #444', borderRadius: '3px', overflow: 'hidden' }}>
            {['FR', 'EN'].map(lang => (
              <button key={lang} onClick={() => setSiteLang(lang)} style={{ padding: '3px 8px', border: 'none', cursor: 'pointer', fontSize: '10px', fontWeight: '700', backgroundColor: siteLang === lang ? '#FF0066' : 'transparent', color: siteLang === lang ? '#fff' : '#888' }}>{lang}</button>
            ))}
          </div>
          <button onClick={handleCreateClick} style={{ backgroundColor: '#FF0066', color: '#fff', border: 'none', padding: '5px 12px', borderRadius: '3px', fontSize: '10px', cursor: 'pointer', fontWeight: '700' }}>
            {siteLang === 'FR' ? 'CRÉER MON COMPOSITE' : 'CREATE MY COMPOSITE'}
          </button>
        </div>
      </header>
    </>
  );
}